import {
  MYCOURSE_DATA_FETCH_END, MYCOURSE_DATA_FETCH_START, MYCOURSE_FETCH_END,
  MYCOURSE_FETCH_START,
} from '../constants';


/**
 * 我的课程数据混排-
 * 混排规则为： 第一页精品课数据，之后是云课堂数据，云课堂数据展示完再展示精品课数据
 * @param {Array} youdaoData  精品课课程
 * @param {Array} studyData   云课堂课程
 * @return {Array} courses    混排之后的课程
 */
const mixedCourse = (youdaoData = [], studyData = []) => {
  // 云课堂加上标识
  const sData = studyData.map(item => ({
    ...item,
    isStudy: true,
  }))
  const courses = [...youdaoData, ...sData];
  return courses;
};

export default function runtime(state = {
  inited: false,
  hasMore: false,
  courses: [],
  isFetchMore: false,
}, action) {
  switch (action.type) {
    case MYCOURSE_FETCH_START:
      return Object.assign({}, state, {
        isFetchMore: true,
      })
    // eslint-disable-next-line no-case-declarations
    case MYCOURSE_FETCH_END:
      const courses = [...state.courses].concat(action.data);
      return {
        yCourses: action.data,
        hasMore: action.data && action.data.length >= 30,
        isFetchMore: false,
        inited: true,
        courses,
      }
    case MYCOURSE_DATA_FETCH_START:
      return Object.assign({}, state, {
        isFetchMore: true,
      })
    // eslint-disable-next-line no-case-declarations
    case MYCOURSE_DATA_FETCH_END:
      const course = mixedCourse(action.youdaoData, action.studyData);
      return {
        courses: course,
        hasMore: action.youdaoData.length >= 30,
        isFetchMore: false,
        inited: true,
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/mycourse.js